document.addEventListener('DOMContentLoaded', () => {
  const accTriggers = document.querySelectorAll('[data-acc-trigger]')
  const goTopBtn = document.querySelector('[data-anchor-top]')
  const header = document.getElementById('top')
  const footer = document.querySelector('footer')
  const toggleGoTopBtnVisibility = () => {
    const footerRect = footer?.getBoundingClientRect()
    const isFooterVisible = footerRect && footerRect.top < window.innerHeight && footerRect.bottom >= 0
    if (isFooterVisible) {
      goTopBtn?.classList.add('visible')
    } else {
      goTopBtn?.classList.remove('visible')
    }
  }

  goTopBtn?.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    header?.setAttribute('tabindex', '0')
    header?.focus()
  })

  const toggleAccordion = (trigger: Element) => {
    if (window.innerWidth < 1024) {
      let sibling = trigger.nextElementSibling
      while (sibling && !sibling.matches('[data-acc]')) {
        sibling = sibling.nextElementSibling
      }

      if (sibling) {
        const isOpen = sibling.classList.toggle('!flex')
        trigger.setAttribute('data-acc-trigger', isOpen ? 'open' : 'closed')
      }
    }
  }

  accTriggers.forEach(trigger => {
    trigger.addEventListener('click', () => toggleAccordion(trigger))
  })

  window.addEventListener('resize', () => {
    accTriggers.forEach(trigger => {
      const sibling = trigger.nextElementSibling
      if (sibling && window.innerWidth >= 1024) {
        sibling.classList.add('hidden')
      }
    })
  })

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        goTopBtn?.classList.remove('!hidden')
      } else {
        goTopBtn?.classList.add('!hidden')
      }
    })
  })

  if (footer) {
    observer.observe(footer)
  }

  window.addEventListener('scroll', toggleGoTopBtnVisibility)
  toggleGoTopBtnVisibility()
})
